module.exports = __webpack_public_path__ + "img/microscope.f30188cf.png";